import React from 'react';
import { TextInput } from 'hyperdb-utils';

export default class Form extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <fieldset>
        <TextInput
          label="Name *"
          name="name"
          value={ this.props.objectData.name }
          onChange={ this.handleChange.bind(this, 'name') }
        />
        <TextInput
          label="Description"
          name="description"
          value={ this.props.objectData.description }
          onChange={ this.handleChange.bind(this, 'description') }
        />
      </fieldset>
    );
  }

  handleChange(attributeName, field) {
    const { name, value } = field;
    if (!this.props.onChange) {
      this.props.api.propertyGroup.updateEditedObject({ attributeName, value });
    } else {
      const objectData = { ...this.props.objectData, [attributeName]: value };
      this.props.onChange(objectData);
    }
  }
}

Form.propTypes = {
  api: React.PropTypes.object,
  objectData: React.PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/propertyGroup/components/Form.jsx